import React, { Component } from "react";
import { connect } from "react-redux";
import AdminNavBar from "../../components/UI/AdminNavBar";
import Footer from "../../components/UI/Footer";
import * as Sentry from "@sentry/react";
import { AWS_URL } from "../../assets/Constants";

import {
  store,
  getFromLocalStorage,
  saveToLocalStorage,
  deleteFromLocalStorage,
} from "../../store";
import {
  Form,
  Container,
  Button,
  Row,
  Col,
  Accordion,
  Card,
  Modal,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import config from "../../services/apiConfig";
import { apiPaths } from "../../services/apiPath";
import Spinner from "react-bootstrap/Spinner";
import "./style.css";
import ErrorFallbackComponent from "../../screens/ErrorFallBackScreen";

class IncidentReportScreen extends Component {
  state = {
    isSuperAdminLoggedIn:
      getFromLocalStorage("isSuperAdminLoggedIn") != "undefined" &&
      getFromLocalStorage("isSuperAdminLoggedIn") != "" &&
      getFromLocalStorage("isSuperAdminLoggedIn") != null
        ? getFromLocalStorage("isSuperAdminLoggedIn")
        : "false",
    isAccountantLoggedIn:
      getFromLocalStorage("isAccountantLoggedIn") != "undefined" &&
      getFromLocalStorage("isAccountantLoggedIn") != "" &&
      getFromLocalStorage("isAccountantLoggedIn") != null
        ? getFromLocalStorage("isAccountantLoggedIn")
        : "false",
    isStockAdminLoggedIn:
      getFromLocalStorage("isStockAdminLoggedIn") != "undefined" &&
      getFromLocalStorage("isStockAdminLoggedIn") != "" &&
      getFromLocalStorage("isStockAdminLoggedIn") != null
        ? getFromLocalStorage("isStockAdminLoggedIn")
        : "false",
    isEventCoordinatorLoggedIn:
      getFromLocalStorage("isEventCoordinatorLoggedIn") != "undefined" &&
      getFromLocalStorage("isEventCoordinatorLoggedIn") != "" &&
      getFromLocalStorage("isEventCoordinatorLoggedIn") != null
        ? getFromLocalStorage("isEventCoordinatorLoggedIn")
        : "false",
    emails: [],
    tempEmailList: [],
  };

  componentDidMount() {
    const {
      isSuperAdminLoggedIn,
      isEventCoordinatorLoggedIn,
      isStockAdminLoggedIn,
      isAccountantLoggedIn,
    } = this.state;
    if (
      isSuperAdminLoggedIn === "true" ||
      isEventCoordinatorLoggedIn === "true"
    ) {
      this.getEmailsToVendor();
    } else {
      window.location.href = "/admin";
    }
  }

  getEmailsToVendor = () => {
    var url = config.BASE_URI + apiPaths.adminData;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      payload: {
        body: {
          query_type: "get_all_incident_logs",
        },
      },
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((dataResponse) => {
        if (dataResponse.success == true) {
          this.setState({
            emails: dataResponse.incident_logs,
            tempEmailList: dataResponse.incident_logs,
          });
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error(error);
        alert("Something went wrong");
      });
  };

  logout = () => {
    deleteFromLocalStorage("isSuperAdminLoggedIn", "false");
    deleteFromLocalStorage("isEventCoordinatorLoggedIn", "false");
    deleteFromLocalStorage("isAccountantLoggedIn", "false");
    deleteFromLocalStorage("isStockAdminLoggedIn", "false");
    this.setState({ isEventCoordinatorLoggedIn: "false" });
    this.setState({ isAccountantLoggedIn: "false" });
    this.setState({ isStockAdminLoggedIn: "false" });
    this.setState({ isSuperAdminLoggedIn: "false" });
    window.location.reload();
  };

  render() {
    const {
      isSuperAdminLoggedIn,
      isEventCoordinatorLoggedIn,
      isAccountantLoggedIn,
      isStockAdminLoggedIn,
    } = this.state;
    return (
      <div>
        <AdminNavBar
          isSuperAdminLoggedIn={isSuperAdminLoggedIn}
          isEventCoordinatorLoggedIn={isEventCoordinatorLoggedIn}
          isAccountantLoggedIn={isAccountantLoggedIn}
          isStockAdminLoggedIn={isStockAdminLoggedIn}
          logout={this.logout}
        />
        {!isSuperAdminLoggedIn || !isEventCoordinatorLoggedIn
          ? (window.location.href = "/admin")
          : this.renderHome()}
      </div>
    );
  }

  renderHome() {
    const { emails, searchVendor } = this.state;
    var emailList = this.state.emails;

    return (
      <div>
        <Container
          style={{
            borderWidth: 1,
            borderColor: "grey",
            borderStyle: "solid",
            borderRadius: 5,
            padding: 15,
          }}
        >
          <h4>Incident Reports</h4>
          <>
            <InputGroup className="mb-3">
              <InputGroup.Text value={searchVendor}>
                <img
                  style={{ width: 20 }}
                  src={require("../../assets/img/search.gif")}
                ></img>
              </InputGroup.Text>
              <FormControl
                aria-label="Search for incidents"
                onChange={(e) => {
                  var searchString = e.target.value;
                  if (searchString == "") {
                    this.setState({ emails: this.state.tempEmailList });
                  } else {
                    var result = emailList.filter((obj) => {
                      if (
                        obj.vendor__title.search(
                          new RegExp(searchString, "i")
                        ) != -1
                      ) {
                        console.log(obj);
                        return obj;
                      }
                    });
                    this.setState({ emails: result });
                  }
                }}
              />
            </InputGroup>
            <Row className="table-header-row">
              <Col xs={12} md={1} lg={1} className="table-header-col">
                SR No.
              </Col>
              <Col xs={12} md={2} lg={2} className="table-header-col">
                Incident Type
              </Col>
              <Col xs={12} md={3} lg={3} className="table-header-col">
                Location
              </Col>
              <Col xs={12} md={2} lg={2} className="table-header-col">
                Date
              </Col>
              <Col xs={12} md={2} lg={2} className="table-header-col">
                Reported By
              </Col>
              <Col xs={12} md={2} lg={2} className="table-header-col">
                Status
              </Col>
            </Row>
            {emails.map((item, i) => {
              return (
                <Accordion key={item.id}>
                  <>
                    <Accordion.Toggle as={Card.Header} eventKey={item.id}>
                      <>
                        <Row className="table-row">
                          <Col xs={12} md={1} lg={1} className="table-col">
                            <span>
                              <b className="mobile-only">Sr No:</b> {item.id}
                            </span>
                          </Col>
                          <Col xs={12} md={2} lg={2} className="table-col">
                            <span>
                              <b className="mobile-only">Incident Type:</b>{" "}
                              {item.incident_type}
                            </span>
                          </Col>
                          <Col xs={12} md={3} lg={3} className="table-col">
                            <span>
                              <b className="mobile-only">Location:</b>{" "}
                              {item.location}
                            </span>
                          </Col>
                          <Col xs={12} md={2} lg={2} className="table-col">
                            <span>
                              <b className="mobile-only">Date:</b>{" "}
                              {item.date}
                            </span>
                          </Col>
                          <Col xs={12} md={2} lg={2} className="table-col">
                            <span>
                              <b className="mobile-only">Reported By:</b>{" "}
                              {item.reported_to}
                            </span>
                          </Col>
                          <Col xs={12} md={2} lg={2} className="table-col">
                            <span>
                              <b className="mobile-only">Status:</b>{" "}
                              {item.was_employee_on_duty ? "On Duty" : "Off Duty"}
                            </span>
                          </Col>
                        </Row>
                      </>
                    </Accordion.Toggle>
                    <Accordion.Collapse
                      eventKey={item.id}
                      style={{ padding: 20, backgroundColor: "#eff2f5" }}
                    >
                      <>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Date and Time of the Incident
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.date_and_time_of_the_incident}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Description
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.description}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Did Employee Return
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.did_employee_return ? "Yes" : "No"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Did Employee Stop Work
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.did_employee_stop_work ? "Yes" : "No"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Filler Name
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.filler_name}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Filler Position
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.filler_position}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Filler Contact
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.filler_contact}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            First Aid Description
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.first_aid_description}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            First Aider Name
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.first_aider_name}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            First Aider Contact
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.first_aider_contact}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            How Long Was Duty
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.how_long_was_duty}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Stopped Work Date and Time
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.stopped_work_date_time}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Witness Name
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.witness_name}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Witness Contact
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.witness_contact}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Witness Relation
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.witness_relation}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Witness Statement
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.witness_statement}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Operator First Name
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.operator__first_name || "N/A"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Operator Last Name
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.operator__last_name || "N/A"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Relation
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.relation}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Note
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            {item.note}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Personal Damage 
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                          <a
                                  href={
                                    AWS_URL +
                                    "/" +
                                    item.person_damage_images
                                  }
                                  target="_blank"
                                >
                                  {}{"Personal Damage  "}
                                </a>
                            
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Vehicle Damage
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                          <a
                                  href={
                                    AWS_URL +
                                    "/" +
                                    item.vehicle_damage_images
                                  }
                                  target="_blank"
                                >
                                  {}{"Vehicle Damage "}
                                </a>
                            
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6} md={6} lg={6}>
                            Incident Attachment
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                          <a
                                  href={
                                    AWS_URL +
                                    "/" +
                                    item.incident_attachment
                                  }
                                  target="_blank"
                                >
                                  {}{"Incident Attachment "}
                                </a>
                            
                          </Col>
                        </Row>
                      </>
                    </Accordion.Collapse>
                  </>
                </Accordion>
              );
            })}
          </>
        </Container>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedTab: state.appReducer.selectedTab,
    vendorData: state.appReducer.vendorData,
    filters: state.appReducer.filters,
    selectedCategory: state.appReducer.selectedCategory,
    loggedIn: state.appReducer.loggedIn,
    smsSent: state.appReducer.smsSent,
    loginModalToggle: state.appReducer.loginModalToggle,
    phone: state.appReducer.phone,
    userId: state.appReducer.userId,
    token: state.appReducer.token,
    username: state.appReducer.username,
    email: state.appReducer.email,
    userAddress: state.appReducer.userAddress,
    userImg: state.appReducer.userImg,
    userLocation: state.appReducer.userLocation,
    currentLatitude: state.appReducer.currentLatitude,
    currentLongitude: state.appReducer.currentLongitude,
    selectedVendorData: state.appReducer.selectedVendorData,
  };
}

export default connect(mapStateToProps)(
  Sentry.withErrorBoundary(IncidentReportScreen, {
    fallback: <ErrorFallbackComponent />,
  })
);
